export class DSException {
  constructor(public description: string) {}
}
